export const IS_MAINTENANCE_MODE = true

// Exempt only a resolved route whose path is exactly '/'. Unknown paths and the router's
// unresolved start route (matched is empty) show the maintenance page.
export function isExemptFromMaintenance(route) {
  return route.path === '/' && route.matched.length > 0
}

export function showsMaintenancePage(
  route,
  isMaintenanceMode = IS_MAINTENANCE_MODE
) {
  return isMaintenanceMode && !isExemptFromMaintenance(route)
}
